import { Component, OnInit } from '@angular/core';
import { InformacaoPlano } from '../../../models/informacao-plano/informacao-plano.model';
import { LoadingService } from '../../../util/loader.service';
import { InformacaoPlanoService } from './informacao-plano.service';

@Component({
  selector: 'app-informacao-plano',
  templateUrl: './informacao-plano.component.html',
  styleUrls: ['./informacao-plano.component.scss']
})
export class InformacaoPlanoComponent implements OnInit {
  record: InformacaoPlano;
  constructor(
    public loader: LoadingService,
    public service: InformacaoPlanoService) { }

  ngOnInit() {
    this.load();
  }
  load() {
    this.loader.show("body");
    this.service.obterInformacaoPlano().subscribe(itens => {
      this.loader.hide("body");
      this.record = itens as InformacaoPlano;


    });
  }
}
